"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("a-select", _vm._b({
    attrs: {
      "filter-option": false,
      "show-search": true,
      "show-arrow": true,
      loading: _vm.targetLoading
    },
    on: {
      blur: _vm.handleBlur,
      search: _vm.debouncedSearch,
      popupScroll: _vm.handleScroll,
      dropdownVisibleChange: _vm.handleDropdown
    },
    scopedSlots: _vm._u([{
      key: "dropdownRender",
      fn: function (menu) {
        return [_c("v-nodes", {
          attrs: {
            vnodes: menu
          }
        }), _vm.targetLoading ? _c("div", {
          staticClass: "m-text-center m-p-4 m-tips-color"
        }, [_c("a-icon", {
          attrs: {
            type: "loading"
          }
        }), _vm._v(" 加载中...")], 1) : _vm._e(), _vm.mode !== "default" && _vm.showSelectAllBtn ? _c("div", {
          staticClass: "m-flex m-row-between m-p-8"
        }, [_c("a-button", {
          staticClass: "m-flex-1",
          attrs: {
            type: "error",
            size: "small"
          },
          on: {
            click: function ($event) {
              return _vm.selectToggle("clear");
            }
          }
        }, [_vm._v("清空")]), _c("a-tooltip", {
          attrs: {
            title: _vm.allTargetValue.length === 0 ? null : !!_vm.searchValue ? `选择符合搜索条件的${_vm.allTargetValue.length}条数据` : `选择全部${_vm.allTargetValue.length}条数据`
          }
        }, [_c("div", {
          staticClass: "m-flex-1 m-m-l-8"
        }, [_c("a-button", {
          attrs: {
            block: "",
            disabled: _vm.allTargetValue.length === 0,
            type: "primary",
            size: "small"
          },
          on: {
            click: function ($event) {
              return _vm.selectToggle("all");
            }
          }
        }, [_vm._v("全选")])], 1)])], 1) : _vm._e()];
      }
    }]),
    model: {
      value: _vm.selected,
      callback: function ($$v) {
        _vm.selected = $$v;
      },
      expression: "selected"
    }
  }, "a-select", _vm.targetProps, false), _vm._l(_vm.uniqFilterOptions, function (item, index) {
    return _c("a-select-option", {
      key: index,
      attrs: {
        title: item[_vm.replaceFields.label],
        value: item[_vm.replaceFields.value]
      }
    }, [_vm._v(" " + _vm._s(item[_vm.replaceFields.label]) + " ")]);
  }), 1);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;